module.exports = __webpack_public_path__ + "img/cycling.be5030ca.webp";